import { render, staticRenderFns } from "./ColorsGridWhatNotToDo.vue?vue&type=template&id=5c7f4b82"
import script from "./ColorsGridWhatNotToDo.vue?vue&type=script&lang=ts"
export * from "./ColorsGridWhatNotToDo.vue?vue&type=script&lang=ts"
import style0 from "./ColorsGridWhatNotToDo.vue?vue&type=style&index=0&id=5c7f4b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports